import { useState } from "react";
import { message, Table, Form, Popconfirm, Button, Tooltip, Card } from "antd";
import styles from "./management.module.scss";
import NotifiModalC from "./components/NotificationC";
import { SchemeModalC } from "./components/SchemeC";
import GroupModalC from "./components/GroupModalC";
import { TokenModelC } from "./components/TokenC";
import CreateInfoModalF from "./components/CustomerInfoModalC_Create";
import EditCustomerInfoF from "./components/CustomerInfoModalC_Edit";
import UserModaC from "./components/UserModalC";
import { useTranslation } from "react-i18next";
import EventLogC from "./components/EventLogC";
// import { BsPencil, BsListTask, BsPeople, BsPerson, BsVolumeUp, BsTrash, BsFileText } from "react-icons/bs";
// import { AiOutlineKey } from "react-icons/ai";
import { useAppSelector } from "store/hook";
import { useCustomerInf, useDeleteCustomerInf } from "./queries";

import {
  EditOutlined,
  UserOutlined,
  // GroupOutlined,
  KeyOutlined,
  NotificationOutlined,
  HistoryOutlined,
  DeleteOutlined,
  ProfileOutlined,
  ClusterOutlined,
} from "@ant-design/icons";
// 客戶資訊
export interface custInfRecordProps {
  cid: string | undefined;
  inf_list?: { company?: string; contact?: string; mail?: string; phone?: number };
}

const Management = () => {
  const [form] = Form.useForm();
  const [CreateVisible, setCreateVisible] = useState(false);
  const [CreateUservisible, setCreateUservisible] = useState(false);
  const [NotifiModalvisible, setNotifiModalvisible] = useState(false);
  const [SchemeModalvisible, setSchemeModalvisible] = useState(false);
  const [eventLogModalvisible, setEventLogModalvisible] = useState(false);
  const [GroupModalvisible, setGroupModalvisible] = useState(false);
  const [Tokenvisible, setTokenvisible] = useState(false);
  const [EditCustomerInfovisible, setEditCustomerInfovisible] = useState(false);
  const [record, setRecord] = useState<custInfRecordProps>({ cid: undefined });
  const { stateCid, level, loginCid } = useAppSelector((state) => state.global);
  const { t } = useTranslation();
  const { data: customerInf, isLoading: customerInfLoading } = useCustomerInf(level, stateCid, loginCid);
  const { mutateAsync: deleteCustomerInfMutation, isLoading: deleteCustomerInfLoading } = useDeleteCustomerInf();
  const loading = customerInfLoading || deleteCustomerInfLoading;

  const deleteUserInfo = (record: custInfRecordProps) => {
    deleteCustomerInfMutation({ cid: record.cid })
      .then(() => {
        message.success(t("ISMS.Success"));
      })
      .catch(() => {
        message.error(t("ISMS.Fail"));
      });
  };

  const columns = [
    {
      title: t("ISMS.Customer"),
      dataIndex: ["inf_list", "company"],
      // dataIndex: ["company"],
      key: "company",
    },
    {
      title: t("ISMS.Operation"),
      dataIndex: "information",
      key: "information",
      render: (_: string, record: custInfRecordProps) => {
        return (
          <div className={styles.InformationBtnWrapper}>
            <Tooltip title={t("ISMS.EditInformation")}>
              {/* <a
                href="/#"
                onClick={(e) => {
                  e.preventDefault();
                  setRecord(record);
                  setEditCustomerInfovisible(true);
                }}
              >
                <EditOutlined />
              </a> */}

              <Button
                type="text"
                onClick={() => {
                  setRecord(record);
                  setEditCustomerInfovisible(true);
                }}
                icon={<EditOutlined />}
              ></Button>
            </Tooltip>
            {(level === "super_super" || level === "super") && (
              <Tooltip title={t("ISMS.Scheme")}>
                <Button
                  type="text"
                  onClick={() => {
                    setRecord(record);
                    setSchemeModalvisible(true);
                  }}
                  icon={<ProfileOutlined />}
                ></Button>
                {/* <a
                  href="/#"
                  onClick={(e) => {
                    e.preventDefault();
                    setRecord(record);
                    setSchemeModalvisible(true);
                  }}
                >
                  <ProfileOutlined />
                </a> */}
              </Tooltip>
            )}
            <Tooltip title={t("ISMS.User")}>
              <Button
                type="text"
                onClick={() => {
                  setCreateUservisible(true);
                  setRecord(record);
                }}
                icon={<UserOutlined />}
              ></Button>

              {/* <a
                href="/#"
                onClick={(e) => {
                  e.preventDefault();
                  setCreateUservisible(true);
                  setRecord(record);
                }}
              >
                <UserOutlined />
              </a> */}
            </Tooltip>

            <Tooltip title={t("ISMS.DeviceGroup")}>
              <Button
                type="text"
                onClick={() => {
                  setRecord(record);
                  setGroupModalvisible(true);
                }}
                icon={<ClusterOutlined />}
              ></Button>

              {/* <a
                href="/#"
                onClick={(e) => {
                  e.preventDefault();
                  setRecord(record);
                  setGroupModalvisible(true);
                }}
              >
                <GroupOutlined />
              </a> */}
            </Tooltip>
            <Tooltip title={t("ISMS.Token")}>
              <Button
                type="text"
                onClick={() => {
                  setRecord(record);
                  setTokenvisible(true);
                }}
                icon={<KeyOutlined />}
              ></Button>

              {/* <a
                href="/#"
                onClick={(e) => {
                  e.preventDefault();
                  setRecord(record);
                  setTokenvisible(true);
                }}
              >

                <KeyOutlined />
              </a> */}
            </Tooltip>
            <Tooltip title={t("ISMS.Notification")}>
              <Button
                type="text"
                onClick={() => {
                  setRecord(record);
                  setNotifiModalvisible(true);
                }}
                icon={<NotificationOutlined />}
              ></Button>

              {/* <a
                href="/#"
                onClick={(e) => {
                  e.preventDefault();
                  setRecord(record);
                  setNotifiModalvisible(true);
                }}
              >
                <NotificationOutlined />
              </a> */}
            </Tooltip>
            <Tooltip title={t("ISMS.EventLog")}>
              <Button
                type="text"
                onClick={() => {
                  setRecord(record);
                  setEventLogModalvisible(true);
                }}
                icon={<HistoryOutlined />}
              ></Button>

              {/* <a
                href="/#"
                onClick={(e) => {
                  e.preventDefault();
                  setRecord(record);
                  setEventLogModalvisible(true);
                }}
              >

                <HistoryOutlined />
              </a> */}
            </Tooltip>
            {level === "super_super" && stateCid === "" && (
              <Tooltip title={t("ISMS.DeleteCustomer")}>
                <Popconfirm
                  title={t("ISMS.Sure to delete?")}
                  okText={t("ISMS.OK")}
                  cancelText={t("ISMS.Cancel")}
                  onConfirm={() => {
                    deleteUserInfo(record);
                  }}
                >
                  <Button icon={<DeleteOutlined />} type="text"></Button>
                </Popconfirm>
              </Tooltip>
            )}
          </div>
        );
      },
    },
  ];

  return (
    <div>
      <CreateInfoModalF CreateVisible={CreateVisible} setCreateVisible={setCreateVisible} />

      <EditCustomerInfoF
        EditCustomerInfovisible={EditCustomerInfovisible}
        setEditCustomerInfovisible={setEditCustomerInfovisible}
        record={record}
        setRecord={setRecord}
      />

      <SchemeModalC
        SchemeModalvisible={SchemeModalvisible}
        setSchemeModalvisible={setSchemeModalvisible}
        record={record}
        setRecord={setRecord}
      />

      <UserModaC
        record={record}
        setRecord={setRecord}
        CreateUservisible={CreateUservisible}
        setCreateUservisible={setCreateUservisible}
      />

      <GroupModalC
        GroupModalvisible={GroupModalvisible}
        setGroupModalvisible={setGroupModalvisible}
        record={record}
        setRecord={setRecord}
      />

      <TokenModelC
        Tokenvisible={Tokenvisible}
        setTokenvisible={setTokenvisible}
        record={record}
        setRecord={setRecord}
      />

      <NotifiModalC
        NotifiModalvisible={NotifiModalvisible}
        setNotifiModalvisible={setNotifiModalvisible}
        record={record}
        setRecord={setRecord}
      />

      <EventLogC
        eventLogModalvisible={eventLogModalvisible}
        setEventLogModalvisible={setEventLogModalvisible}
        record={record}
        setRecord={setRecord}
      />

      <Card>
        {level === "super_super" && stateCid === "" && (
          <Button
            type="primary"
            onClick={() => setCreateVisible(true)}
            className={styles.NewUserInfoBtn}
            loading={loading}
          >
            {t("ISMS.Create Customer")}
          </Button>
        )}

        {deleteCustomerInfLoading && (
          <span style={{ fontWeight: 600, color: "blue" }}>deleting customer, please wait.</span>
        )}

        <Form form={form} component={false} layout="vertical">
          <Table
            className={styles.UserInfoTable}
            loading={loading}
            columns={columns}
            // dataSource={customerInf?.response || []}
            dataSource={customerInf?.response || []}
            // @ts-ignore
            rowKey={(record) => record.cid}
          />
        </Form>
      </Card>
    </div>
  );
};

export default Management;
